import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Check if we're on a page with a dark hero (all pages currently have dark heroes)
  const isDarkHero = true;
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About Us',
    path: '/about'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Projects',
    path: '/projects'
  }, {
    name: 'Industries',
    path: '/industries'
  }, {
    name: 'Insights',
    path: '/insights'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy-900/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-100">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between" data-id="element-101">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 group" data-id="element-102">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-tech-blue to-tech-green flex items-center justify-center text-white font-bold text-xl shadow-lg group-hover:shadow-tech-green/50 transition-shadow" data-id="element-103">
            IT
          </div>
          <span className={`font-bold text-xl tracking-tight transition-colors ${isScrolled || isDarkHero ? 'text-white' : 'text-navy-900'}`} data-id="element-104">
            Invigo<span className="text-tech-green" data-id="element-105">Tech</span>
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-106">
          {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-tech-green ${location.pathname === link.path ? 'text-tech-green' : isScrolled || isDarkHero ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-107">
              {link.name}
            </Link>)}
          <Link to="/contact" className="px-5 py-2.5 text-sm font-semibold text-white bg-tech-blue rounded-full hover:bg-blue-600 transition-colors shadow-lg hover:shadow-tech-blue/50" data-id="element-108">
            Get in Touch
          </Link>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className={`md:hidden p-2 rounded-md ${isScrolled || isDarkHero ? 'text-white' : 'text-navy-900'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-109">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-110" /> : <Menu className="w-6 h-6" data-id="element-111" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-112">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-900 border-t border-white/10 overflow-hidden" data-id="element-113">
            <div className="px-4 py-6 flex flex-col gap-4" data-id="element-114">
              {navLinks.map(link => <Link key={link.name} to={link.path} className={`flex items-center justify-between py-3 border-b border-white/5 text-lg font-medium ${location.pathname === link.path ? 'text-tech-green' : 'text-slate-300'}`} data-id="element-115">
                  {link.name}
                  <ChevronRight className="w-5 h-5 opacity-50" data-id="element-116" />
                </Link>)}
              <Link to="/contact" className="mt-4 w-full py-4 text-center text-base font-semibold text-white bg-tech-green rounded-lg shadow-lg" data-id="element-117">
                Start Your Project
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}